import React from "react";
import { GetServerSideProps, NextPage } from "next";

import { getDispensary } from "api/requests/getDispensary";
import { DISPENSARY_PAGES } from "constants/dispensary";
import { Dispensary } from "custom-types/Dispensary";
import { doctorsMetadata } from "lib/dispensaryMetadata";
import isDispensaryUnclaimed from "utils/dispensary/isDispensaryUnclaimed";
import generateDispensaryRedirect from "utils/generateDispensaryRedirect";
import { getCountryCodeHeader } from "utils/requestContext";

import AboutDispensary from "components/Dispensary/AboutDispensary";
import DispensaryHeader from "components/Dispensary/DispensaryHeader";
import DispensaryTabs from "components/Dispensary/DispensaryTabs";
import DoctorClaimPanel from "components/Dispensary/DoctorClaimPanel";
import MetaTags from "components/MetaTags";

type Props = {
  dispensary: Dispensary;
};

const DoctorPage: NextPage<Props> = ({ dispensary }) => {
  const { coverPhotoUrl, logoUrl, name } = dispensary;
  const { description, image, title } = doctorsMetadata(
    coverPhotoUrl,
    logoUrl,
    name,
  );
  const isUnclaimed = isDispensaryUnclaimed(dispensary);

  return (
    <>
      <MetaTags
        canonicalParams={[]}
        description={description}
        image={image}
        title={title}
      />
      <DispensaryHeader dispensary={dispensary} isMainPage={true} />
      <DispensaryTabs
        activeTab={DISPENSARY_PAGES.main}
        dispensary={dispensary}
      />
      {isUnclaimed ? (
        <DoctorClaimPanel />
      ) : (
        <AboutDispensary dispensary={dispensary} />
      )}
    </>
  );
};
export const getServerSideProps: GetServerSideProps = async (context) => {
  const { query, req } = context;
  const { slug } = query;

  const domainCountryCode = getCountryCodeHeader(req.headers);

  const dispensary = await getDispensary(slug as string);

  const redirect = generateDispensaryRedirect(
    domainCountryCode,
    context.resolvedUrl,
    context.query,
    dispensary,
  );

  if (redirect) {
    return { redirect };
  }

  return {
    props: { dispensary },
  };
};

export default DoctorPage;
